"use client";
import React, { useState, useEffect } from "react";
import LanguageSwitcher from "../../Element_Components/languageSwitcher/languageSwitcherElement";
import Image from "next/image";
import Link from "next/link";
import Socials from "../../Element_Components/socials/Socials";
import { collectionLoader } from "@/utils/fetchCollection";
import { getBaseUrl } from "@/lib/getBaseURL";
import dataLoader from "@/utils/fetchSingleType";
import { useLanguage } from "@/app/LanguageContext";
import InternalBoardButton from "../../Element_Components/internalBoard/InternalBoardButton";
interface Language {
  name: string;
  code: string;
  isDefault: boolean;
}
interface Type {
  type: string;
  
}
interface Poll {
  title: string;
  endDate:string;
}
const TopHeader = ({ type }: Type) => {
  const { language } = useLanguage();
  const [poll, setPoll] = useState<Poll | null>(null);
  const [languages, setLanguages] = useState<Language[]>([
    {
      name: "",
      code: "",
      isDefault: true,
    },
  ]);
  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const baseUrl = getBaseUrl();
        const response = await fetch(`${baseUrl}/api/i18n/locales`);
        const data = await response.json();

        console.log("Language response:", data);

        setLanguages(data as Language[]);
      } catch (error) {
        console.error("Failed to fetch languages:", error);
      }
    };

    fetchLanguages();
    const fetchPoll = async () => {
      const response = await dataLoader<Poll>("poll",language);
      setPoll(response);
    };
    fetchPoll();
  }, []);
  return (
    <header className="w-full">
      {/* Top Flag Bar */}
      {/* <div
        className="w-full h-1"
        style={{
          background:
            "linear-gradient(to right, #042129 0%, #042129 50%, #359657 50%, #359657 100%)",
        }}
      ></div> */}

      {/* Header Content */}
      <div className="bg-[#F4F4F4]">
        <div className="flex items-center justify-between w-full xl:w-[71rem] mx-auto py-2 px-5 xl:px-0">
          {type == "Region" && (
            <div className="items-center space-x-2 flex">
              <img src="/e_flag.svg" alt="ethiopian flag" className="w-8 h-4" />
              <img
                src="/central_flag.png"
                alt="South Ethiopia region flag"
                className="w-8 h-4"
              />
            </div>
          )}
          {/* <h2 className="text-slate-500 text-sm font-semibold md:block hidden">
              South Ethiopia Region Web Portal
            </h2> */}
          {/* </div> */}

          {/* Right-aligned Social and Language */}
          <div className="ml-auto flex items-center space-x-1 md:space-x-6 text-gray-800">
          {poll&&poll.endDate>new Date().toISOString() && (
              <a href={"/poll"} className="text-sm">{poll?.title}</a>
            )}
            <Socials className="" />
            <InternalBoardButton language={language}/>
            <LanguageSwitcher languages={languages} />
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopHeader;
